import { render, staticRenderFns } from "./PracticeFees.vue?vue&type=template&id=ab3bb66c&scoped=true&"
import script from "./PracticeFees.vue?vue&type=script&lang=js&"
export * from "./PracticeFees.vue?vue&type=script&lang=js&"
import style0 from "./PracticeFees.vue?vue&type=style&index=0&id=ab3bb66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3bb66c",
  null
  
)

export default component.exports